import styled from 'styled-components';

export const DetailCard = styled.div`
  border-radius: 16px;
  box-shadow: 0 2px 16px 0 ${({ theme }) => theme.hotelDetails.detailCard};
  background-color: ${({ theme }) => theme.hotelDetails.background};
  padding: 16px;
  margin-top: 32px;
`;

export const Info = styled.div`
  padding-top: 24px;
  padding-bottom: 14px;

  & p {
    padding-top: 8px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
  }
`;

export const SubTitle = styled.h5`
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: ${({ theme }) => theme.hotelDetails.subtitleColor};
`;

export const SeeMore = styled.button`
  width: 100%;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.hotelDetails.background};
  cursor: pointer;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
